<script setup>
import { computed } from 'vue';

const props = defineProps({
  links: {
    type: Array,
    default: () => [],
  },
});

const visibleLinks = computed(() => props.links.filter(link => link.label && link.url));
</script>

<template>
  <div v-if="visibleLinks.length" class="course-modal__cta-sidebar">
    <ul class="course-modal__cta-sidebar-block">
      <li
        v-for="link in visibleLinks"
        :key="link.url"
        class="course-modal__cta-item"
        :class="link.type"
      >
        <a
          :href="link.url"
          class="course-modal__cta-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>{{ link.label }}</span>
        </a>
        <div class="course-modal__cta-icon" aria-hidden="true">
          <svg data-dir="up_right" viewBox="0 0 1001.79 901.97" xmlns="http://www.w3.org/2000/svg">
            <line
              fill="none"
              stroke-linecap="round"
              vector-effect="non-scaling-stroke"
              x1="0.7"
              x2="999.79"
              y1="450.8"
              y2="450.8"
            ></line>
            <polyline
              fill="none"
              points="461.58 0.99 1000.7 450.8 461.58 900.99"
              stroke-linecap="round"
              vector-effect="non-scaling-stroke"
            ></polyline>
          </svg>
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped></style>
